// extracted by mini-css-extract-plugin
export default {"buttons":"styles-buttons-1OMj2"};